export default __webpack_public_path__ + "static/media/sa1.f80a0874.jpg";